import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form,  Button, Message} from 'semantic-ui-react'
import _ from 'lodash';
import fs from 'fs';
import mkdirp from 'mkdirp';
import general from '../../../modulos/general';

// import { createWriteStream, unlink } from 'fs';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

// import SeguroPermite from '../../../components/funcionales/seguropermite'
import EstaSeg7Btn from '../../../components/funcionales/estaseg7btn';

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'


const DetalleNivel1 = ({elemento, handleClickidLista, idListaP}) => {
  let urlSlcm = 'https://montserratslcm.com/api/cotizaciones/'

  return(
    <tr className=''>  
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.fechaCreate.substr(0, 10)}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.numCoti}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.nombreUsuario}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrEmpresa}</td>
      <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.valorUniAprob?new Intl.NumberFormat('de-DE').format(elemento.valorUniAprob):0}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.cantidadAprob?new Intl.NumberFormat('de-DE').format(elemento.cantidadAprob):0}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.titulo}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.fechaAut?elemento.fechaAut.substr(0, 10):""}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.estadoCoti}</td>
      <td className='' style={{color: 'black', background: '#FFFFFF'}}>
        <a style={{color: 'black'}}
          // href={'images/cotizaciones/' + elemento.archivoEnviado}
          href={urlSlcm + elemento.archivoEnviado}
            target="_blank">
          {elemento.archivoEnviado}
        </a>
      </td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.observaciones}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.observacionesAut}</td>
   </tr>
  )
};


const Lista = ({list, handleClickidLista, idListaP}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetalleNivel1 elemento={elemento} handleClickidLista={handleClickidLista}
        key={i} idListaP={idListaP}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class AdminEnvCoti2 extends React.Component {
  state={argsBuscCad: {}, idListaP: [], argsDocum: {ruta: 0}, checked: true, permiteUpdate: true, confirmaAct: false,
      open: false, errors: [], procBtn: 0, permiteBtn1: true, permiteBtn2: true, permiteBtn3: true, 
      argsQuery: `{"$unwind": "$itemsCoti"},
      {$project: {_id: {$concat: ['$numCoti', '$itemsCoti.descrProducto']}, numCoti: 1,
          descrProducto: '$itemsCoti.descrProducto', 
          cantidadCoti: '$itemsCoti.cantidadCoti', 
          valorUniCoti: '$itemsCoti.valorUniCoti', 
          porcDcto: '$itemsCoti.porcDcto',
          porcIncremento: '$itemsCoti.porcIncremento',
          porcIVA: '$itemsCoti.porcIVA',
          descrUnidad: '$itemsCoti.descrUnidad',
          moneda: '$itemsCoti.moneda',
          ficha: '$itemsCoti.ficha',
          ficha2: '$itemsCoti.ficha2'}},
      {$sort: {descrProducto: 1}}`,
      argsQuery1: `{$match: {tipoCoti: 'Cliente', estadoCoti: 'Aprobada'}},
      {$project: {_id: 1, 
        itemsCoti: {
          $let: {
            vars: {regItem: { $cond: { if: { $isArray: "$itemsCoti" },
                                          then: { $size: "$itemsCoti" },
                                          else: 0} }
            },
            in: { $cond: { if: { $gt: [ "$$regItem", 0 ] },
                                then: "$itemsCoti",
                                else: [{cantidadAprob: 0, valorUniAprob: 0, porcIVA: 0, porcDcto: 0, porcIncremento: 0}] 
            }}
        }},      
        fechaCreate: 1, numCoti: 1, nombreUsuario: 1, titulo: 1, fechaAut: 1, fechaEnvio: 1, fechaRta: 1, 
        monedaCoti: 1, imptoCoti: 1,
        descrPolitica: 1, titulo2: 1, parrafo2: 1, titulo3: 1, parrafo3: 1, ciudad: 1, email: 1, telefono: 1, 
        tipo: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, cedula: 1, nombreContacto: 1, cargoContacto: 1, ciudadContacto: 1,
        mailContacto: 1, telContacto: 1, referencia: 1, tiempoEntrega: 1, lugarEntrega: 1, formaPago: 1, validezOferta: 1, observacionesAut: 1, usuarioAut: 1,
        estadoCoti: 1, archivoEnviado: 1, observaciones: 1}},
      {"$unwind": "$itemsCoti"},
      {$project: {_id: 1, fechaCreate: 1, numCoti: 1, nombreUsuario: 1, titulo: 1, fechaAut: 1, fechaEnvio: 1, fechaRta: 1, 
        descrPolitica: 1, titulo2: 1, parrafo2: 1, titulo3: 1, parrafo3: 1, ciudad: 1, email: 1, telefono: 1, 
        monedaCoti: 1, imptoCoti: 1,
        tipo: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, cedula: 1, nombreContacto: 1, cargoContacto: 1, 
        ciudadContacto: 1, mailContacto: 1, telContacto: 1, referencia: 1, tiempoEntrega: 1, lugarEntrega: 1, formaPago: 1, 
        validezOferta: 1, observacionesAut: 1, usuarioAut: 1, estadoCoti: 1, archivoEnviado: 1, observaciones: 1, cantidadAprob: '$itemsCoti.cantidadAprob', 
        valorUniAprob: '$itemsCoti.valorUniAprob', porcIVA: '$itemsCoti.porcIVA', porcDcto: '$itemsCoti.porcDcto', porcIncremento: '$itemsCoti.porcIncremento'}},   
      {$project: {_id: 1, fechaCreate: 1, numCoti: 1, nombreUsuario: 1, titulo: 1, fechaAut: 1, fechaEnvio: 1, fechaRta: 1, 
        descrPolitica: 1, titulo2: 1, parrafo2: 1, titulo3: 1, parrafo3: 1, ciudad: 1, email: 1, telefono: 1, 
        monedaCoti: 1, imptoCoti: 1,
        tipo: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, cedula: 1, nombreContacto: 1, cargoContacto: 1, 
        ciudadContacto: 1, mailContacto: 1, telContacto: 1, referencia: 1, tiempoEntrega: 1, lugarEntrega: 1, formaPago: 1, 
        validezOferta: 1, observacionesAut: 1, usuarioAut: 1, estadoCoti: 1, archivoEnviado: 1, observaciones: 1,
        valorItem: {
          $let: {
              vars: {cantidadAprob: {$toInt: '$cantidadAprob'}, valorUniAprob: '$valorUniAprob', porcDcto: {$toDouble: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
              in: { $multiply: [ "$$cantidadAprob", {$multiply: [{$divide: ["$$valorUniAprob", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}
          }
        },
        valorItemIVA: {
          $let: {
            vars: {cantidadAprob: {$toInt: '$cantidadAprob'}, valorUniAprob: '$valorUniAprob', porcIVA: {$toInt: '$porcIVA'}, porcDcto: {$toDouble: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
            in: { $multiply: [{ $multiply: [ "$$cantidadAprob", {$multiply: [{$divide: ["$$valorUniAprob", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}, {$add: [1, {$divide: [ "$$porcIVA", 100 ]} ]}]}
          }
        }
      }},
      {$group: {_id: {_id: '$_id', fechaCreate: '$fechaCreate', numCoti: '$numCoti', nombreUsuario: '$nombreUsuario', titulo: '$titulo',
      fechaAut: '$fechaAut', fechaEnvio: '$fechaEnvio', fechaRta: '$fechaRta',
      monedaCoti: '$monedaCoti', imptoCoti: '$imptoCoti',
      descrPolitica: '$descrPolitica', titulo2: '$titulo2', parrafo2: '$parrafo2', 
      ciudad: '$ciudad', email: '$email', telefono: '$telefono', 
      titulo3: '$titulo3', parrafo3: '$parrafo3', 
      tipo: '$tipo', ciudadFechaEnvio: '$ciudadFechaEnvio', 
      descrEmpresa: '$descrEmpresa', cedula: '$cedula', nombreContacto: '$nombreContacto', 
      cargoContacto: '$cargoContacto', 
    ciudadContacto: '$ciudadContacto', mailContacto: '$mailContacto', telContacto: '$telContacto', 
      referencia: '$referencia', tiempoEntrega: '$tiempoEntrega', lugarEntrega: '$lugarEntrega', 
      formaPago: '$formaPago', 
    validezOferta: '$validezOferta', observacionesAut: '$observacionesAut', usuarioAut: '$usuarioAut', 
      estadoCoti: '$estadoCoti', archivoEnviado: '$archivoEnviado', observaciones: '$observaciones'},
    valorTotal: {$sum: {$toDouble: '$valorItem'}}, valorTotalIVA: {$sum: {$toDouble: '$valorItemIVA'}}
    }},
    {$project: {_id: '$_id._id', fechaCreate: "$_id.fechaCreate",
        numCoti: '$_id.numCoti', nombreUsuario: '$_id.nombreUsuario', titulo: "$_id.titulo",
        fechaAut: '$_id.fechaAut', fechaEnvio: '$_id.fechaEnvio',
        monedaCoti: '$_id.monedaCoti', imptoCoti: '$_id.imptoCoti',
        fechaRta: '$_id.fechaRta', descrPolitica: '$_id.descrPolitica', tipo: '$_id.tipo', 
        titulo2: '$_id.titulo2', parrafo2: '$_id.parrafo2', titulo3: '$_id.titulo3', parrafo3: '$_id.parrafo3', 
        ciudad: '$_id.ciudad', email: '$_id.email', telefono: '$_id.telefono',   
        ciudadFechaEnvio: '$_id.ciudadFechaEnvio', descrEmpresa: '$_id.descrEmpresa', cedula: '$_id.cedula', 
          nombreContacto: '$_id.nombreContacto', cargoContacto: '$_id.cargoContacto', 
    ciudadContacto: '$_id.ciudadContacto', mailContacto: '$_id.mailContacto', telContacto: '$_id.telContacto', 
          referencia: '$_id.referencia', tiempoEntrega: '$_id.tiempoEntrega', lugarEntrega: '$_id.lugarEntrega', 
          formaPago: '$_id.formaPago', 
    validezOferta: '$_id.validezOferta', observacionesaAut: '$_id.observacionesAut', usuarioAut: '$_id.usuarioAut', 
          estadoCoti: '$_id.estadoCoti', archivoEnviado: '$_id.archivoEnviado', observaciones: '$_id.observaciones', 
          valorUniAprob: {$toDouble: '$valorTotal'}, cantidadAprob: {$toDouble: '$valorTotalIVA'}
      }}, {$sort: {fechaCreate: -1}}`
  }

  crudBD = async (operacionCRUD, args, i)=>{
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });

//Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        const {data} = await operacionCRUD({
          variables: args
        });
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }
    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i], i)
    }
  }

  handleChange = (ev) => {
    // const updState = (listDocum) => {
    //   this.setState({listDocum, errors: []})
    // };
  }

  handleEnviar = async (ev, idListaP)=>{
    if(idListaP.numCoti){
      let response = await this.props.fecha({
        variables: {}
      });

      let trmHoy = 0
      if(this.props.getParametro.getParametro){
        trmHoy = this.props.getParametro.getParametro.trm
        trmHoy=trmHoy.replace(",", ".")
      }
console.log(trmHoy)

      const {fechaHoraHoy} = response.data.fecha
      let fechaEnvio = fechaHoraHoy
      let usuarioEnvio = localStorage.getItem('userLogin')
      document.body.style.cursor = 'wait'

      const argsUpd = {
        _id: idListaP._id,
        estadoCoti: 'Enviada',
        fechaEnvio: fechaEnvio,
        usuarioEnvio: usuarioEnvio,
        trm: trmHoy,
        tipoAct: 'EditarEnvio'
      }

      response = await this.props.editCotizacion({
        variables: argsUpd
      });
      const {errors, success} = response.data.editCotizacion;
      if (!success){
        this.setState({errorAdd: errors})
      }else{
        this.props.allCotizacionRtesEnv.refetch()
        document.body.style.cursor = 'default'

        alert("!! Cotización enviada !!")
      }
    }else{
      alert("!! Por favor seleccione una cotización !!")
    }
    this.setState({permiteBtn1: true, permiteBtn2: true, permiteBtn3: true, open: false, confirmaAct: false})
  }

  handleReversar = async (ev, idListaP)=>{
    console.log(idListaP)
    if(idListaP.numCoti){
      document.body.style.cursor = 'wait'

      const argsUpd = {
        _id: idListaP._id,
        estadoCoti: 'Creada',
        fechaEnvio: '',
        usuarioEnvio: '',
        tipoAct: 'EditarEnvio'
      }
console.log(argsUpd)
      let response = await this.props.editCotizacion({
        variables: argsUpd
      });
      const {errors, success} = response.data.editCotizacion;
      if (!success){
        this.setState({errorAdd: errors})
      }else{
        this.props.allCotizacionRtesEnv.refetch()
        document.body.style.cursor = 'default'

        alert("!! Estado reversado !!")
      }
    }else{
      alert("!! Por favor seleccione una cotización !!")
    }
    this.setState({permiteBtn1: true, permiteBtn2: true, permiteBtn3: true, open: false, confirmaAct: false})
  }
 
  handleCopiaInfPdf = async (ev, idListaP)=>{
    console.log(idListaP)
    if(idListaP.numCoti){
      document.body.style.cursor = 'wait'
      let list1 = idListaP
      let dirSlcm = 'images/logos/LCMSAS.png'
      let imgSource = new Image();
      // let rutaArch = 'D:/Software//slcm//slcm-client//public//images//fichas//'   //local
      // let rutaArch = '/home//slcm//slcm-client//public//images//fichas//'   //Servidor
      // let rutaArch = 'https://montserratslcm.com/home/slcm/slcm-client/public/images/fichas/'
      let rutaArch = 'https://montserratslcm.com/api/fichas/'

      let response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = response.data.fecha
      let doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})
      // let widthDoc = (doc.internal.pageSize.width)
      let widthDoc = 180
      let heightDoc = (doc.internal.pageSize.height)
      let heightDisponible=heightDoc
      let empresa = {rutaLogo: "",
      empresaRazonSocial: "",
      empresaNit: "",
      empresaWeb: "",
      empresaDir1: "",
      empresaTel1: "",
      empresaCel1: "",
      empresaCiudad1: "",
      empresaDir2: "",
      empresaTel2: "",
      empresaCel2: "",
      empresaCiudad2: "",
      empresaBanco1: "",
      empresaCuenta1: "",
      empresaBanco2: "",
      empresaCuenta2: "",
      empresaPresentacion: "",
      empresaNombreFirma: "",
      empresaCargoFirma: "",
      empresaNombreFirma2: list1.nombreUsuario?list1.nombreUsuario:"",
      empresaCargoFirma2: list1.ciudad?list1.ciudad:"",
      empresaMailFirma: list1.email?list1.email:"",
      empresaCelFirma: list1.telefono?list1.telefono:"",
      empresaWeb: ""}
      if(this.props.getParametro.getParametro){
        empresa.empresaRazonSocial = this.props.getParametro.getParametro.empresaRazonSocial
        empresa.rutaLogo = this.props.getParametro.getParametro.rutaLogo
        empresa.empresaNit = this.props.getParametro.getParametro.empresaNit
        empresa.empresaWeb = this.props.getParametro.getParametro.empresaWeb
        empresa.empresaDir1 = this.props.getParametro.getParametro.empresaDir1
        empresa.empresaTel1 = this.props.getParametro.getParametro.empresaTel1
        empresa.empresaCel1 = this.props.getParametro.getParametro.empresaCel1
        empresa.empresaCiudad1 = this.props.getParametro.getParametro.empresaCiudad1
        empresa.empresaDir2 = this.props.getParametro.getParametro.empresaDir2
        empresa.empresaTel2 = this.props.getParametro.getParametro.empresaTel2
        empresa.empresaCel2 = this.props.getParametro.getParametro.empresaCel2
        empresa.empresaCiudad2 = this.props.getParametro.getParametro.empresaCiudad2
        empresa.empresaBanco2 = this.props.getParametro.getParametro.empresaBanco2
        empresa.empresaCuenta2 = this.props.getParametro.getParametro.empresaCuenta2
        empresa.empresaPresentacion = this.props.getParametro.getParametro.empresaPresentacion
        empresa.empresaBanco1 = this.props.getParametro.getParametro.empresaBanco1
        empresa.empresaCuenta1 = this.props.getParametro.getParametro.empresaCuenta1
        empresa.empresaNombreFirma = this.props.getParametro.getParametro.empresaNombreFirma
        empresa.empresaCargoFirma = this.props.getParametro.getParametro.empresaCargoFirma
        // empresa.empresaMailFirma = empresaMailFirma
        // empresa.empresaCelFirma = empresaCelFirma
        empresa.empresaWeb = this.props.getParametro.getParametro.empresaWeb
      }
      doc.setPage()
      doc.setFontType("arial")
      doc.setFontSize(10);
      // doc.setTextColor(150);
      doc.setFontStyle('Normal');

      doc.text(list1.ciudadFechaEnvio, 20, 35, 'left')
      doc.text("Señores:", 20, 45, 'left') 
      doc.setFontStyle('bold');
      doc.text(list1.descrEmpresa, 20, 49, 'left')   
      doc.setFontStyle('Normal');
      doc.text(list1.cargoContacto, 20, 53, 'left') 
      doc.text(list1.nombreContacto, 20, 57, 'left')    
      doc.text(list1.mailContacto, 20, 61, 'left')    
      doc.text(list1.telContacto, 20, 65, 'left')    
      doc.text(list1.ciudadContacto, 20, 69, 'left')   
      doc.setFontStyle('bold'); 
      doc.text("REF:  " + list1.referencia + " - " + list1.numCoti, 20, 79, {align: 'left',lineHeightFactor: 1.1,maxWidth:widthDoc})    
      let posic = 95
      doc.setFontStyle('normal');
      let parrafo = empresa.empresaPresentacion.split("\n")
      console.log(parrafo)
      parrafo.forEach((texto, ii) => {   
        let lineas = doc.splitTextToSize(texto, widthDoc)
        console.log(lineas)
        if(texto){
          console.log(texto)
          doc.text(texto, 20, posic, {align: 'justify',lineHeightFactor: 1.1,maxWidth:widthDoc}) 
          posic+=(4*lineas.length)+1
        }
      })
      doc.text("Cordialmente", 20, posic + 30, 'left') 
      try{
        imgSource.src = dirSlcm;
        doc.convertStringToImageData(imgSource)
        doc.addImage(imgSource, 'PNG', 20, posic + 34, 55, 17);
      }catch{
        console.log("Logo de LCM no existe")
      }
      doc.text(empresa.empresaNombreFirma, 20, posic + 54, 'left')  
      doc.setFontStyle('bold');  
      doc.setTextColor(255,0,0);
      doc.text(empresa.empresaCargoFirma, 20, posic + 58, 'left')
      doc.text(empresa.empresaMailFirma, 20, posic + 62, 'left') 
      doc.text(empresa.empresaCelFirma, 20, posic + 66, 'left') 
 

      doc.setFontStyle('normal'); 
      doc.setTextColor("black");
      doc.addPage()
      doc.text("1.  COTIZACIÓN:", 20, 35, 'left')

      let argsBuscar=""
      argsBuscar += `'numCoti': '${idListaP.numCoti}'`
      let argsBuscarIt = {}
      argsBuscarIt = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
      let {data} = await this.props.allCotizacionRtesEnv1.refetch(argsBuscarIt)
      let lista4 = []
      lista4 = await data.allCotizacionRtes

      let columnasCot = ["COTIZACION"];
      let datosCot = [];
      doc.autoTable(columnasCot, datosCot,{
        margin: { left: 20, top : 30},
        startY: 39.8,
        rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
        styles: {
          fontSize: 9,
          lineColor: "black",
          lineWidth: 0.1,
          valign: "top",
        },
        headStyles: {
          fillColor: "#FFCA33",
          textColor: "black",
          halign: "center",
          valign: "top",
          cellPadding: 1,
          fontStyle: "bold",
          fontSize: 9
        },
        // bodyStyles: {
        //   fillColor: "white",
        //   textColor: "black",
        //   halign: "center",
        //   cellPadding: 1,
          // minCellHeight: 1.8
        // },
        columnStyles: {
          0: {cellWidth: 184},
        }
      })

      // let columnasCoti = ["No.", "Descripción", "Ficha tec.", "Ficha seg.", "Cant.", "Unidad", "Vlr Unitario", "% Dto", "% Incremento", "Vlr total"];
      let columnasCoti = ["No.", "Descripción", "Ficha tec.", "Ficha seg.", "Cant.", "Unidad", "Vlr Unitario", "Vlr total"];

      let tablaCoti = []
      let totalCoti = 0, totalIVA = 0, subTotal = 0, numLineas = 0, totalDcto = 0, totalInc = 0
      posic = 50
      heightDisponible=heightDoc-25
      let lineasProd = 0
      let lineasUni = 0
      let argsUpd = []
      let moneda = 'Pesos'

      lista4.forEach((elemento1, iii) => {
        numLineas = lista4.length
        argsUpd.push(iii+1)

        if(elemento1.moneda==='Dolares'){
          moneda='Dolares'
        }

        let parrafoProd = elemento1.descrProducto.split("\n")
        let heightLineaItem=0
        let parrafoUni = elemento1.descrUnidad.split("\n")

        parrafoProd.forEach((textoProd, ii) => {   
          lineasProd = doc.splitTextToSize(textoProd, 75)
          lineasUni = doc.splitTextToSize(parrafoUni, 20)
          if(textoProd){
            if(lineasProd.length===1){
              if(lineasUni.length===1){
                posic+=5
                heightLineaItem=5
              }else{
                posic+=4.65*lineasUni.length
                heightLineaItem=(4.65*lineasUni.length)
              }            
            }else{
              posic+=4.65*lineasProd.length
              heightLineaItem=(4.65*lineasProd.length)
            }
            if(heightLineaItem>heightDisponible){
              posic=35+heightLineaItem
              heightDisponible=heightDoc-60-heightLineaItem
            }else{
              heightDisponible=heightDisponible-heightLineaItem
            }
          }
        })

        let valorUni=0
        argsUpd.push(parrafoProd)
        argsUpd.push("")
        argsUpd.push("")
        argsUpd.push(new Intl.NumberFormat('de-DE').format(elemento1.cantidadCoti))
        argsUpd.push(elemento1.descrUnidad)
        if(moneda==='Pesos'){
          // valorUni=(elemento1.valorUniCoti / ((100-elemento1.porcIncremento)/100))
          valorUni=Math.round((elemento1.valorUniCoti / ((100-elemento1.porcIncremento)/100)))
          argsUpd.push(new Intl.NumberFormat('de-DE').format(Math.round(valorUni)))
          argsUpd.push(new Intl.NumberFormat('de-DE').format(Math.round(valorUni) * elemento1.cantidadCoti))
          console.log(elemento1.valorUniCoti)
          subTotal+=(elemento1.valorUniCoti / ((100-elemento1.porcIncremento)/100)) * elemento1.cantidadCoti
          // subTotal+=Math.round((elemento1.valorUniCoti / ((100-elemento1.porcIncremento)/100)) * elemento1.cantidadCoti)
          console.log(subTotal)
        }else{
          valorUni=(elemento1.valorUniCoti / ((100-elemento1.porcIncremento)/100))
          argsUpd.push(new Intl.NumberFormat('de-DE').format(valorUni.toFixed(2)))
          argsUpd.push(new Intl.NumberFormat('de-DE').format((valorUni * elemento1.cantidadCoti).toFixed(2)))
          subTotal+=valorUni * elemento1.cantidadCoti
        }        

        if(elemento1.porcDcto>0){
          if(moneda==='Pesos'){
            totalDcto+=Math.round((valorUni-(valorUni * ((100-elemento1.porcDcto)/100))) * elemento1.cantidadCoti)
            valorUni=valorUni * ((100-elemento1.porcDcto)/100)
            valorUni=Math.round(valorUni)
          }else{
            totalDcto+=(valorUni-(valorUni * ((100-elemento1.porcDcto)/100))) * elemento1.cantidadCoti
            valorUni=valorUni * ((100-elemento1.porcDcto)/100)
          }
        }
        if(elemento1.porcIVA>0){
          totalIVA+=valorUni * elemento1.cantidadCoti * (elemento1.porcIVA/100)
        }

        tablaCoti.push(argsUpd)
        argsUpd = []
      })
      totalCoti=subTotal - totalDcto + totalIVA      
      let impuesto = list1.imptoCoti?list1.imptoCoti:'IVA'
      impuesto+=" "
      
      argsUpd.push("")
      argsUpd.push("")
      argsUpd.push("")
      argsUpd.push("")
      argsUpd.push("")
      argsUpd.push("")
      argsUpd.push("Subtotal")
      if(moneda==='Pesos'){
        argsUpd.push(new Intl.NumberFormat('de-DE').format(Math.round(subTotal)))
      }else{
        argsUpd.push(new Intl.NumberFormat('de-DE').format(subTotal.toFixed(2)))
      }
      tablaCoti.push(argsUpd)
      argsUpd = []

      argsUpd.push("")
      argsUpd.push("")
      argsUpd.push("")
      argsUpd.push("")
      argsUpd.push("")
      argsUpd.push("")
      argsUpd.push("Descuento")
      if(moneda==='Pesos'){
        argsUpd.push(new Intl.NumberFormat('de-DE').format(Math.round(totalDcto)))
      }else{
        argsUpd.push(new Intl.NumberFormat('de-DE').format(totalDcto.toFixed(2)))
      }
      tablaCoti.push(argsUpd)
      argsUpd = []

      argsUpd.push("")
      argsUpd.push("")
      argsUpd.push("")
      argsUpd.push("")
      argsUpd.push("")
      argsUpd.push("")
      argsUpd.push(impuesto)
      if(moneda==='Pesos'){
        argsUpd.push(new Intl.NumberFormat('de-DE').format(Math.round(totalIVA)))
      }else{
        argsUpd.push(new Intl.NumberFormat('de-DE').format(totalIVA.toFixed(2)))
      }
      tablaCoti.push(argsUpd)
      argsUpd = []

      argsUpd.push("")
      argsUpd.push("")
      argsUpd.push("")
      argsUpd.push("")
      argsUpd.push("")
      argsUpd.push("")
      if(moneda==='Pesos'){
        argsUpd.push("Total $")
        argsUpd.push(new Intl.NumberFormat('de-DE').format(Math.round(totalCoti)))
      }else{
        argsUpd.push("Total $US")
        argsUpd.push(new Intl.NumberFormat('de-DE').format(totalCoti.toFixed(2)))
      }
      tablaCoti.push(argsUpd)
      argsUpd = []

      let datosCoti = tablaCoti;      
      doc.autoTable(columnasCoti,datosCoti,{
        // margin: 20,
        startY: 45.5,
        margin: { left: 20, top : 30},        
        rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
        // showHead: 'everyPage',
        styles: {
          fontSize: 9,
          lineColor: "black",
          lineWidth: 0.1,
          valign: "top",
        },
        headStyles: {
          fillColor: "#FFCA33",
          textColor: "black",
          halign: "center",
          // valign: "top",
          cellPadding: 1,
          fontStyle: "bold",
          fontSize: 9,
          minCellHeight: 2
        },
        bodyStyles: {
          fillColor: "white",
          textColor: "black",
          halign: "center",
          cellPadding: 0.5,
          // minCellHeight: 1.8
        },
        columnStyles: {
          0: {cellWidth: 7},
          1: {cellWidth: 73},
          2: {cellWidth: 10},
          3: {cellWidth: 10},
          4: {cellWidth: 10},
          5: {cellWidth: 24},
          6: {cellWidth: 20},
          // 7: {cellWidth: 10},
          // 8: {cellWidth: 24},
          9: {cellWidth: 20},
        },
        didParseCell(data) {
          if((data.row.index === numLineas || data.row.index === numLineas+1 || data.row.index === numLineas+2 || data.row.index === numLineas+3) && data.section==='body'){
            if(data.column.index === 0){
              data.cell.colSpan = 6
              data.cell.rowSpan = 4
            }
          }
          if(data.row.index !== -1 && data.section==='body' && data.column.index === 1){

          }
        },

        didDrawCell: (data) => {
          //imagenes en autoTable
          //https://github.com/simonbengtsson/jsPDF-AutoTable/issues/93
          if(data.row.index===-1){
            console.log("ojoooo")
          }
          console.log(rutaArch, lista4)
          if(data.row.index !== -1 && data.section==='body' && data.column.index === 2){
            if(lista4[data.row.index].ficha){
              doc.setTextColor('#3366BB');
              doc.textWithLink('PDS', data.cell.x + 2, data.cell.y + 4, {url: 'https://montserratslcm.com/images/fichas/' + lista4[data.row.index].ficha})
              doc.setTextColor('black');
            }
          }
          if(data.row.index !== -1 && data.section==='body' && data.column.index === 3){
            if(lista4[data.row.index].ficha2){
              doc.setTextColor('#3366BB');
              doc.textWithLink('SDS', data.cell.x + 2, data.cell.y + 4, {url: 'https://montserratslcm.com/images/fichas/' + lista4[data.row.index].ficha2})
              doc.setTextColor('black');
            }
          }
        }
      })

      posic+=35
// console.log(posic, heightDoc, heightDisponible)
      heightDisponible=heightDoc-posic
// console.log(posic, heightDoc, heightDisponible)


      doc.setFontStyle('bold');
      doc.text("Observaciones: ", 20, posic, 'left')
      doc.setFontStyle('normal');

      if(list1.observaciones && list1.observaciones!==''){
        let parrafoObs = list1.observaciones.split("\n")
        let heightLineaObs=0
        parrafoObs.forEach((texto, ii) => {   
          if(texto){
            let lineasObs = doc.splitTextToSize(texto, widthDoc)
            heightLineaObs=(4*lineasObs.length)
            if(heightLineaObs>heightDisponible){
              posic=35
              heightDisponible=heightDoc-25
              doc.addPage()
            }
            doc.text(texto.trim(), 20, posic+5, {align: 'justify',lineHeightFactor: 1.1,maxWidth:widthDoc}) 
            posic+=4*lineasObs.length
            heightDisponible-=4*lineasObs.length
          }
        })

      }
// console.log(posic, heightDoc, heightDisponible)

      if(heightDisponible<45){
        posic=35
        heightDisponible=heightDoc-25
        doc.addPage()
      }

      doc.text("* Tiempo de entrega: " + list1.tiempoEntrega, 20, posic+10, 'left')   
      doc.text("* Luga de entrega: " + list1.lugarEntrega, 20, posic+14, 'left')   
      doc.text("* Forma de pago: " + list1.formaPago, 20, posic+18, 'left')   
      doc.text("* Validez de la oferta: " + list1.validezOferta, 20, posic+22, 'left')  
      doc.text("* Moneda: " + list1.monedaCoti, 20, posic+26, 'left')
      if((list1.tipo==="Producto" && list1.formaPago!=='Anticipado 100%') || list1.tipo!=="Producto"){
        doc.text("Se ilustra a continuación la política de LCMSAS de descuentos por forma de pago, el cliente puede elegir la modalidad a utilizar", 20, posic+31, {align: 'justify',lineHeightFactor: 1.2,maxWidth:widthDoc})
      }
      posic = posic+40
      heightDisponible-=40

      if(heightDisponible<45){
        posic=35
        heightDisponible=heightDoc-25
        doc.addPage()
      }
      let datos = []
      let sumaPosic=0
      let columnas = ["Forma de pago", "Descuento"];
      if(list1.tipo==="Producto"){
        let poli1="Se puede otorgar un descuento del 30% por pago anticipado del 100%."
        switch(list1.formaPago){
          case 'Pago >= 90 días':
            console.log("1")
          datos = [
            ["Anticipado 100%", "Se puede otorgar un descuento del 30% por pago anticipado " + "\n" + "del 100%."],
            ["Anticipo 50% contra entrega 50%", "Se puede otorgar un descuento del 25% por pago anticipado 50% " + "\n" + "contra entrega 50%"],
            ["Contra entrega 100%", "Se puede otorgar un descuento del 20% por pago contra entrega " + "\n" + "100%"], 
            ["Pago < 30 días después de radicar factura", "Se puede otorgar un descuento del 15% por pago < 30 días " + "\n" + "después de radicar factura"],
            ["Pago entre 30 >= y < 60 días después de radicar factura", "Se puede otorgar un descuento del 10% por pago entre " + "\n" + "30 >= y < 60 días después de radicar factura"], 
            ["Pago entre 60 >= y < 90 días después de radicar factura", "Se puede otorgar un descuento del 5% por pago entre " + "\n" + "60 >= y < 90 días después de radicar factura"] 
          ];
          sumaPosic=60
          break
          case 'Pago entre 60 >= y < 90 días':
            console.log("2")
            datos = [
              ["Anticipado 100%", "Se puede otorgar un descuento del 25% por pago anticipado " + "\n" + "del 100%."],
              ["Anticipo 50% contra entrega 50%", "Se puede otorgar un descuento del 20% por pago anticipado 50% " + "\n" + "contra entrega 50%"],
              ["Contra entrega 100%", "Se puede otorgar un descuento del 15% por pago contra entrega " + "\n" + "100%"], 
              ["Pago < 30 días después de radicar factura", "Se puede otorgar un descuento del 10% por pago < 30 días " + "\n" + "después de radicar factura"],
              ["Pago entre 30 >= y < 60 días después de radicar factura", "Se puede otorgar un descuento del 5% por pago entre " + "\n" + "30 >= y < 60 días después de radicar factura"]
            ];
            sumaPosic=55
            break
          case 'Pago entre 30 >= y < 60 días':
            console.log("3")
            datos = [
              ["Anticipado 100%", "Se puede otorgar un descuento del 20% por pago anticipado " + "\n" + "del 100%."],
              ["Anticipo 50% contra entrega 50%", "Se puede otorgar un descuento del 15% por pago anticipado 50% " + "\n" + "contra entrega 50%"],
              ["Contra entrega 100%", "Se puede otorgar un descuento del 10% por pago contra entrega " + "\n" + "100%"], 
              ["Pago < 30 días después de radicar factura", "Se puede otorgar un descuento del 5% por pago < 30 días " + "\n" + "después de radicar factura"]
            ];
            sumaPosic=45
            break
          case 'Pago = 30 días':
            console.log("4")
            datos = [
              ["Anticipado 100%", "Se puede otorgar un descuento del 15% por pago anticipado " + "\n" + "del 100%."],
              ["Anticipo 50% contra entrega 50%", "Se puede otorgar un descuento del 10% por pago anticipado 50% " + "\n" + "contra entrega 50%"],
              ["Contra entrega 100%", "Se puede otorgar un descuento del 5% por pago contra entrega " + "\n" + "100%"]
            ];
            sumaPosic=35
            break
          case 'Contra entrega 100%':
            console.log("5")
            datos = [
              ["Anticipado 100%", "Se puede otorgar un descuento del 10% por pago anticipado " + "\n" + "del 100%."],
              ["Anticipo 50% contra entrega 50%", "Se puede otorgar un descuento del 5% por pago anticipado 50% " + "\n" + "contra entrega 50%"]
            ];
            sumaPosic=25
            break
          case 'Anticipo 50% contra entrega 50%':
            console.log("6")
            datos = [
              ["Anticipado 100%", "Se puede otorgar un descuento del 5% por pago anticipado " + "\n" + "del 100%."]
            ];
            sumaPosic=20
            break
          case 'Anticipado 100%':
            console.log("7")
            // datos = [
            //   ["Anticipado 100%", "Descuento del 5% (Antes de iva)"]
            // ];
            sumaPosic=15
            break
          default:
            console.log("8")
            datos = [
              ["", ""] 
            ];
            sumaPosic=15
            break        
        }
      }else{
        console.log("9")
        datos = [
          ["Anticipado 100%", "Descuento del 5% (Antes de iva)"],
          ["Anticipo 50% contra entrega 50%", "Descuento del 3% (Antes de iva)"],
          ["Contra entrega 100%", "Descuento del 2% (Antes de iva)"], 
          ["Pago < 30 días después de radicar factura", "0%"],
          ["Pago entre 30 >= y < 60 días después de radicar factura", "Incremento del 5% (Antes de iva)"], 
          ["Pago entre 60 >= y < 90 días después de radicar factura", "Incremento del 7% (Antes de iva)"],
          ["Pago >= 90 días después de radicar factura", "Incremento del 10% (Antes de iva)"] 
        ];
        sumaPosic=50
      }

      let anchoCol1=88, anchoCol2=96
      if((list1.tipo==="Producto" && list1.formaPago!=='Anticipado 100%') || list1.tipo!=="Producto"){
        if(list1.tipo!=="Producto"){
          anchoCol1=100
          anchoCol2=84
        }
        doc.autoTable(columnas,datos,{
          margin: { left: 20, top : 30},
          startY: posic,
          rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
          styles: {
            fontSize: 8.5,
            lineColor: "black",
            lineWidth: 0.1,
            valign: "top",
          },
          headStyles: {
            fillColor: "#E9E4F0",
            textColor: "black",
            halign: "center",
            valign: "top",
            cellPadding: 1,
            fontStyle: "bold",
            fontSize: 9
          },
          bodyStyles: {
            fillColor: "white",
            textColor: "black",
            halign: "center",
            cellPadding: 0.5,
          },
          columnStyles: {
            0: {cellWidth: anchoCol1},
            1: {cellWidth: anchoCol2}
          }
        })
      }


      posic+=sumaPosic
      // heightDisponible-=50
      
      doc.text("Notas:", 20, posic, 'left') 
      posic+=4
      parrafo = list1.descrPolitica.split("\n")
      let heightLinea=0
      heightDisponible=heightDoc-45-posic
      
      parrafo.forEach((texto, ii) => {   
        if(texto){
          let lineas = doc.splitTextToSize(texto, widthDoc)
          heightLinea=(4*lineas.length)
          if(heightLinea>heightDisponible){
            posic=35
            heightDisponible=heightDoc-25
            doc.addPage()
          }
          doc.text("* " + texto.trim(), 20, posic, {align: 'justify',lineHeightFactor: 1.1,maxWidth:widthDoc}) 
          posic+=4*lineas.length
          heightDisponible-=4*lineas.length
        }
      })

      if(list1.titulo2){
        posic+=4
        doc.setFontType('bold')
        doc.text(list1.titulo2, 20, posic, 'left')   
        doc.setFontType('normal')
        posic += 8
        heightDisponible-=20
        parrafo = list1.parrafo2.split("\n")
        parrafo.forEach((texto, ii) => {   
          if(texto){
            let lineas = doc.splitTextToSize(texto, 180)
            heightLinea=(4*lineas.length)
            if(heightLinea>heightDisponible){
              posic=35
              heightDisponible=heightDoc-35
              doc.addPage()
            }
            doc.text("* " + texto.trim(), 20, posic, {align: 'justify',lineHeightFactor: 1.1,maxWidth:widthDoc}) 
            posic+=4*lineas.length
            heightDisponible-=4*lineas.length
          }
        })
      }
      if(list1.titulo3){
        doc.setFontType('bold')
        doc.text(list1.titulo3, 20, posic+4, 'left')   
        doc.setFontType('normal') 
        posic+=12  
        parrafo = list1.parrafo3.split("\n")
        parrafo.forEach((texto, ii) => {   
          if(texto){
            let lineas = doc.splitTextToSize(texto, widthDoc)
            heightLinea=(4*lineas.length)
            if(heightLinea>heightDisponible){
              posic=35
              heightDisponible=heightDoc-35
              doc.addPage()
            }
            doc.text("* " + texto.trim(), 20, posic, {align: 'justify',lineHeightFactor: 1.1,maxWidth:widthDoc}) 
            posic+=4*lineas.length
            heightDisponible-=4*lineas.length
          }
        })
      }
// console.log(heightDisponible, heightDoc)
      if(heightDisponible>180){
        posic+=8
      }else{
        posic=30
        doc.addPage()
      }
      doc.setFontType('bold')
      doc.text("2.  DATOS BANCARIOS:", 20, posic+4, 'left')
      doc.setFontType('normal')
      doc.text("Cuentas bancaria:", 20, posic+12, 'left') 
      doc.text(empresa.empresaBanco1, 20, posic+16, 'left')   
      doc.text(empresa.empresaCuenta1, 20, posic+20, 'left')   
      doc.text("Beneficiario: ", 20, posic+24, 'left')   
      doc.text(empresa.empresaRazonSocial + " Nit " + empresa.empresaNit, 20, posic+28, 'left') 
      doc.text(empresa.empresaBanco2, 20, posic+36, 'left')   
      doc.text(empresa.empresaCuenta2, 20, posic+40, 'left')   
      doc.text("Beneficiario: ", 20, posic+44, 'left')   
      doc.text(empresa.empresaRazonSocial + " Nit " + empresa.empresaNit, 20, posic+48, 'left')
      
      // if(list1.tipo!=="Producto"){
      //   posic=35
      //   doc.addPage()
      // }else{
      //   posic+=20
      // }
      posic+=58

      doc.text("Atentamente", 20, posic, 'left') 
      try{
        imgSource.src = dirSlcm;
        doc.convertStringToImageData(imgSource)
        doc.addImage(imgSource, 'PNG', 20, posic + 12, 55, 17);
      }catch{
        console.log("Logo de LCM no existe")
      }

      doc.text(empresa.empresaNombreFirma2, 20, posic+40, 'left') 
      doc.text(empresa.empresaCargoFirma2, 20, posic+44, 'left') 
      doc.text(empresa.empresaMailFirma, 20, posic+48, 'left') 
      doc.text(empresa.empresaCelFirma, 20, posic+52, 'left') 
      doc.text(empresa.empresaWeb, 20, posic+56, 'left') 
      doc.text(empresa.empresaDir1, 20, posic+60, 'left') 
      doc.text(empresa.empresaCiudad1, 20, posic+64, 'left') 
      doc.text(empresa.empresaDir2, 20, posic+68, 'left') 
      doc.text(empresa.empresaCiudad2, 20, posic+72, 'left') 

      const pageCount = doc.internal.getNumberOfPages();
      // For each page, print the page number and the total pages
      for(var i = 1; i <= pageCount; i++) {
          // Go to page i
        doc.setPage(i);

//ENCABEZADO DE PAGINA

        dirSlcm = 'images/logos/LCMSAS.png'
        imgSource = new Image();
        try{
          imgSource.src = dirSlcm;
          doc.convertStringToImageData(imgSource)
          doc.addImage(imgSource, 'PNG', 20, 12, 55, 17);
        }catch{
          console.log("Logo de LCM no existe")
        }
//FIN ENCABEZADO DE PAGINA

//PIE DE PAGINA
        doc.setFontSize(8);
        doc.setTextColor(255,0,0);
        doc.setFontStyle('Watermark');
        doc.text(empresa.empresaWeb, widthDoc/1.7, heightDoc-15, 'center')
        doc.text("Colombia - Ecuador - Panamá", widthDoc/1.7, heightDoc-12, 'center') 
        doc.text(fechaHoraHoy.substr(0, 10) + " " + fechaHoraHoy.substr(11, 5), widthDoc-50, heightDoc-12, 'left')
        // doc.text("Dirección: " + empresa.empresaDir1, widthDoc/1.7, heightDoc-21, 'center') 
        // doc.text(empresa.empresaCiudad1, widthDoc/1.7, heightDoc-18, 'center')   
        // doc.text("Dirección: " + empresa.empresaDir2, widthDoc/1.7, heightDoc-15, 'center') 
        // doc.text(empresa.empresaCiudad2, widthDoc/1.7, heightDoc-12, 'center')
//FIN PIE DE PAGINA
      }
      // let dir = 'C:/slcm'
      // const uploadDir = './slcm-client/public/images/cotizaciones/'
      // mkdirp.sync(uploadDir)
      
      let nameDoc = `COTIZACION_${list1.numCoti}.pdf`
      doc.save(nameDoc) 

      document.body.style.cursor = 'default'
    //FIN Exportar a Pdf
      // this.setState({permiteBtn1: true, permiteBtn2: true, permiteBtn3: true, open: false, confirmaAct: false})
    }else{
      alert("!! Por favor seleccione una cotización !!")
    }
  }

  handleClickidLista = async (ev, idListaP)=>{
    ev.preventDefault()

    this.setState({idListaP: idListaP})
  }

  handleQuestionUpdDel = async (ev, btn) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct && this.state.procBtn===0){
      this.setState({open: true})
      this.setState({permiteBtn1: btn==="1"?true:false, permiteBtn2: btn==="2"?true:false, permiteBtn3: btn==="3"?true:false})
    }else{
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true, permiteBtn2: true, permiteBtn3: true})
    };
    if(btnPress==="No"){
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true, permiteBtn2: true, permiteBtn3: true})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      this.setState({procBtn: 1})
      this.setState({permiteBtn1: btn==="1"?true:false, permiteBtn2: btn==="2"?true:false, permiteBtn3: btn==="3"?true:false})
      const myBtn = document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  async componentDidUpdate(prevProps, prevState){
    if((this.props.argsBuscCad!==prevProps.argsBuscCad) || (this.props.list!==prevProps.list)){

      let argsBuscar = `'estadoCoti': 'Aprobada'`

      if(this.props.argsBuscCad.descrEmpresa){
        argsBuscar += `, 'descrEmpresa': /${this.props.argsBuscCad.descrEmpresa}/i`
      }          
      if(this.props.argsBuscCad.numCoti){
        argsBuscar += `, 'numCoti': /${this.props.argsBuscCad.numCoti}/i`
      }
      if(this.props.argsBuscCad.nombreUsuario){
        argsBuscar += `, 'nombreUsuario': /${this.props.argsBuscCad.nombreUsuario}/i`
      }
      let argsBuscCad = ""
      
      argsBuscCad = `{$match: {${argsBuscar}}}, {$sort: {fechaCreate: -1}}`
      
      let argsBuscarIt = {tipoqry: `[${this.state.argsQuery1}, ${argsBuscCad}]`}
      await this.props.allCotizacionRtesEnv.refetch(argsBuscarIt)
      this.setState({idListaP: []})
      this.setState({permiteBtn1: true, permiteBtn2: true, permiteBtn3: true, open: false, confirmaAct: false})

    }
  }

  render(){
    const {idListaP, permiteUpdate, permiteBtn1, permiteBtn2, permiteBtn3, confirmaAct, open, errors, procBtn} = this.state;
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    
    let mensaje1 = "CONFIRMAR ENVÍO DE "
    let imgIcon1 = "images/archivo_32.png"
    let mensaje2 = "GUARDAR PDF DE "
    let mensaje3 = "Eliminar PDF enviado de "
    let mensajeAsImCoti = "Asociar PDF enviado de "
    let mensaje4 = "REVERSAR ESTADO DE " 

    if(idListaP.numCoti){
      mensaje1 += idListaP.numCoti
      mensaje2 += idListaP.numCoti
      mensaje3 += idListaP.numCoti
      mensaje4 += idListaP.numCoti
      mensajeAsImCoti += idListaP.numCoti
    }else{
      mensaje3 += "(Seleccionar...)"
      mensajeAsImCoti += "(Seleccionar...)"
    }

    let list = [], list2 = []
    if(this.props.allCotizacionRtesEnv.allCotizacionRtes){
      this.props.allCotizacionRtesEnv.refetch()
      list = this.props.allCotizacionRtesEnv.allCotizacionRtes
    }

    let trmHoy = 0
    if(this.props.getParametro.getParametro){
      trmHoy = this.props.getParametro.getParametro.trm
      trmHoy=trmHoy.replace(",", ".")
    }
console.log(permiteBtn1, permiteBtn2, permiteBtn3)
    return (
      <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
        <Form name="form1" id="form1" onSubmit={confirmaAct?
          permiteBtn1?
            (ev)=>this.props.handleElimAsDocCoti(ev, idListaP, 'E')
            :permiteBtn2?
              (ev)=>this.handleEnviar(ev, idListaP)
              :permiteBtn3?
                (ev)=>this.handleReversar(ev, idListaP)
                :()=>{}                
          :()=>{}}
        > 

          <div className="ui five column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '20%', paddingTop: '0em'}}>
                {idListaP.numCoti && !idListaP.archivoEnviado &&
                  <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0em 0em 0em 0em'}}>
                    
                  </label>
                }
              </div>
              <div className="column" style={{width: '20%', paddingTop: '0em'}}>
                {idListaP.numCoti && !idListaP.archivoEnviado &&
                  <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0em 0em 0em 0em'}}>
                    {mensajeAsImCoti}
                  </label>
                } 
              </div>
            </div>
            <div className="row container">
              <div className="column" style={{width: '20%', paddingTop: '0.2em'}}>
                <Button id="pdf" name="pdf" style={{...this.props.styles.confirmar, height: '2.7em'}} onClick={(ev)=>this.handleCopiaInfPdf(ev, idListaP)} fluid>
                  {mensaje2}
                </Button>
              </div>              
              <div className="column" style={{width: '20%', paddingLeft: '0.2em'}}>
                {idListaP.numCoti && !idListaP.archivoEnviado &&
                  <Form.Field>
                    <input id="img" name="img" type="file" accept=".pdf,.doc,.docx,.pptx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" multiple={false} style={estilos} onChange={(ev)=>this.props.handleUpdAsDocCoti(ev, idListaP, 'E')}></input>
                  </Form.Field>
                } 
              </div>
              {idListaP.numCoti && idListaP.archivoEnviado && (permiteBtn1) &&
                <div className="column" style={{width: '20%', paddingTop: '0.2em'}}>
                  <EstaSeg7Btn mensaje3={mensaje3} imgIcon3={imgIcon1} open={open}
                    styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "1")}/>
                </div>
              }
              {(permiteBtn2) &&
                <div className="column" style={{width: '20%', paddingTop: '0.2em'}}>
                  <EstaSeg7Btn mensaje1={mensaje1} imgIcon1={imgIcon1} open={open}
                    styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "2")}/>
                </div>
              }
              {(permiteBtn3) &&
                <div className="column" style={{width: '20%', paddingTop: '0.2em'}}>
                    <EstaSeg7Btn mensaje4={mensaje4} imgIcon4={imgIcon1} open={open}
                      styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "3")}/>
                </div>
              }
            </div>
          </div>
          <hr></hr>
          <div>
            <div style={{height: '34em', overflow: 'auto'}}>
              <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                <thead className=''>
                  <tr className=''>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Creada</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Código</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '11%'}}>Responsable</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Cliente</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Valor sin IVA</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Valor con IVA</th>                    
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Política comercial</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Autorizada</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Estado</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Archivo Enviado</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '17%'}}>Observaciones</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '17%'}}>ObservacionesAut</th>
                  </tr>
                </thead>
                <Lista list={list} handleClickidLista={this.handleClickidLista} idListaP={idListaP}/>
              </table>
              <p></p>
            </div>
          </div>
          {
            errors.length?<Message negative header="Los siguientes errores:"
            list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
          }

        </Form>
      </div>
    )
  }
};

export default compose(
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtesEnv1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente', estadoCoti: 'Aprobada'}}, {$sort: {fechaCreate: -1}}]`}}}}),
    graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtesEnv',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente', estadoCoti: 'Aprobada'}},
    {$project: {_id: 1, 
      itemsCoti: {
        $let: {
          vars: {regItem: { $cond: { if: { $isArray: "$itemsCoti" },
                                        then: { $size: "$itemsCoti" },
                                        else: 0} }
          },
          in: { $cond: { if: { $gt: [ "$$regItem", 0 ] },
                              then: "$itemsCoti",
                              else: [{cantidadAprob: 0, valorUniAprob: 0, porcIVA: 0, porcDcto: 0, porcIncremento: 0}] 
          }}
      }},      
      fechaCreate: 1, numCoti: 1, nombreUsuario: 1, titulo: 1, fechaAut: 1, fechaEnvio: 1, fechaRta: 1, 
      monedaCoti: 1, imptoCoti: 1,
      descrPolitica: 1, titulo2: 1, parrafo2: 1, titulo3: 1, parrafo3: 1, ciudad: 1, email: 1, telefono: 1, 
      tipo: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, cedula: 1, nombreContacto: 1, cargoContacto: 1, ciudadContacto: 1,
      mailContacto: 1, telContacto: 1, referencia: 1, tiempoEntrega: 1, lugarEntrega: 1, formaPago: 1, validezOferta: 1, observacionesAut: 1, usuarioAut: 1,
      estadoCoti: 1, archivoEnviado: 1, observaciones: 1}},
    {"$unwind": "$itemsCoti"},
    {$project: {_id: 1, fechaCreate: 1, numCoti: 1, nombreUsuario: 1, titulo: 1, fechaAut: 1, fechaEnvio: 1, fechaRta: 1, 
      descrPolitica: 1, titulo2: 1, parrafo2: 1, titulo3: 1, parrafo3: 1, ciudad: 1, email: 1, telefono: 1, 
      monedaCoti: 1, imptoCoti: 1,
      tipo: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, cedula: 1, nombreContacto: 1, cargoContacto: 1, 
      ciudadContacto: 1, mailContacto: 1, telContacto: 1, referencia: 1, tiempoEntrega: 1, lugarEntrega: 1, formaPago: 1, 
      validezOferta: 1, observacionesAut: 1, usuarioAut: 1, estadoCoti: 1, archivoEnviado: 1, observaciones: 1, cantidadAprob: '$itemsCoti.cantidadAprob', 
      valorUniAprob: '$itemsCoti.valorUniAprob', porcIVA: '$itemsCoti.porcIVA', porcDcto: '$itemsCoti.porcDcto', porcIncremento: '$itemsCoti.porcIncremento'}},   
    {$project: {_id: 1, fechaCreate: 1, numCoti: 1, nombreUsuario: 1, titulo: 1, fechaAut: 1, fechaEnvio: 1, fechaRta: 1, 
      descrPolitica: 1, titulo2: 1, parrafo2: 1, titulo3: 1, parrafo3: 1, ciudad: 1, email: 1, telefono: 1, 
      monedaCoti: 1, imptoCoti: 1,
      tipo: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, cedula: 1, nombreContacto: 1, cargoContacto: 1, 
      ciudadContacto: 1, mailContacto: 1, telContacto: 1, referencia: 1, tiempoEntrega: 1, lugarEntrega: 1, formaPago: 1, 
      validezOferta: 1, observacionesAut: 1, usuarioAut: 1, estadoCoti: 1, archivoEnviado: 1, observaciones: 1,
      valorItem: {
        $let: {
            vars: {cantidadAprob: {$toInt: '$cantidadAprob'}, valorUniAprob: '$valorUniAprob', porcDcto: {$toDouble: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
            in: { $multiply: [ "$$cantidadAprob", {$multiply: [{$divide: ["$$valorUniAprob", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}
        }
      },
      valorItemIVA: {
        $let: {
          vars: {cantidadAprob: {$toInt: '$cantidadAprob'}, valorUniAprob: '$valorUniAprob', porcIVA: {$toInt: '$porcIVA'}, porcDcto: {$toDouble: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
          in: { $multiply: [{ $multiply: [ "$$cantidadAprob", {$multiply: [{$divide: ["$$valorUniAprob", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}, {$add: [1, {$divide: [ "$$porcIVA", 100 ]} ]}]}
        }
      }
    }},
    {$group: {_id: {_id: '$_id', fechaCreate: '$fechaCreate', numCoti: '$numCoti', nombreUsuario: '$nombreUsuario', titulo: '$titulo',
    fechaAut: '$fechaAut', fechaEnvio: '$fechaEnvio', fechaRta: '$fechaRta',
    monedaCoti: '$monedaCoti', imptoCoti: '$imptoCoti',
    descrPolitica: '$descrPolitica', titulo2: '$titulo2', parrafo2: '$parrafo2', 
    ciudad: '$ciudad', email: '$email', telefono: '$telefono', 
    titulo3: '$titulo3', parrafo3: '$parrafo3', 
    tipo: '$tipo', ciudadFechaEnvio: '$ciudadFechaEnvio', 
    descrEmpresa: '$descrEmpresa', cedula: '$cedula', nombreContacto: '$nombreContacto', 
    cargoContacto: '$cargoContacto', 
  ciudadContacto: '$ciudadContacto', mailContacto: '$mailContacto', telContacto: '$telContacto', 
    referencia: '$referencia', tiempoEntrega: '$tiempoEntrega', lugarEntrega: '$lugarEntrega', 
    formaPago: '$formaPago', 
  validezOferta: '$validezOferta', observacionesAut: '$observacionesAut', usuarioAut: '$usuarioAut', 
    estadoCoti: '$estadoCoti', archivoEnviado: '$archivoEnviado', observaciones: '$observaciones'},
  valorTotal: {$sum: {
        $divide: [
          {
            $floor: {
              $multiply: [
                { $toDouble: "$valorItem" },
                100
              ]
            }
          },
          100
        ]
      }},
 valorTotalIVA: {$sum: {
        $divide: [
          {
            $floor: {
              $multiply: [
                { $toDouble: "$valorItemIVA" },
                100
              ]
            }
          },
          100
        ]
      }}
  }},
  {$project: {_id: '$_id._id', fechaCreate: "$_id.fechaCreate",
      numCoti: '$_id.numCoti', nombreUsuario: '$_id.nombreUsuario', titulo: "$_id.titulo",
      fechaAut: '$_id.fechaAut', fechaEnvio: '$_id.fechaEnvio',
      monedaCoti: '$_id.monedaCoti', imptoCoti: '$_id.imptoCoti',
      fechaRta: '$_id.fechaRta', descrPolitica: '$_id.descrPolitica', tipo: '$_id.tipo', 
      titulo2: '$_id.titulo2', parrafo2: '$_id.parrafo2', titulo3: '$_id.titulo3', parrafo3: '$_id.parrafo3', 
      ciudad: '$_id.ciudad', email: '$_id.email', telefono: '$_id.telefono',   
      ciudadFechaEnvio: '$_id.ciudadFechaEnvio', descrEmpresa: '$_id.descrEmpresa', cedula: '$_id.cedula', 
        nombreContacto: '$_id.nombreContacto', cargoContacto: '$_id.cargoContacto', 
  ciudadContacto: '$_id.ciudadContacto', mailContacto: '$_id.mailContacto', telContacto: '$_id.telContacto', 
        referencia: '$_id.referencia', tiempoEntrega: '$_id.tiempoEntrega', lugarEntrega: '$_id.lugarEntrega', 
        formaPago: '$_id.formaPago', 
  validezOferta: '$_id.validezOferta', observacionesaAut: '$_id.observacionesAut', usuarioAut: '$_id.usuarioAut', 
        estadoCoti: '$_id.estadoCoti', archivoEnviado: '$_id.archivoEnviado', observaciones: '$_id.observaciones', 
  valorUniAprob: {
        $divide: [
          {
            $floor: {
              $multiply: [
                { $toDouble: "$valorTotal" },
                100
              ]
            }
          },
          100
        ]
      },
cantidadAprob: {
        $divide: [
          {
            $floor: {
              $multiply: [
                { $toDouble: "$valorTotalIVA" },
                100
              ]
            }
          },
          100
        ]
      }
      }}, 
 {$sort: {fechaCreate: -1}}            
    ]`}}}}),
  graphql(queries.query.getParametro, {name:'getParametro', options: (props) => {return {variables: {}}}}),

  graphql(queries.mutation.editCotizacion, {name:'editCotizacion'}),
  graphql(queries.query.getParametro, {name:'getParametro', options: (props) => {return {variables: {}}}}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(AdminEnvCoti2)
